/**
 * Component to show the listing information for sub organizations
 */
import * as React from 'react';
import { Table, Row } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/CustomerList.scss';
import { Link } from 'react-router-dom';
import strings from '../../eyeguide-localization/customer/strings.customer';
import OrganizationList from '../organization/OrganizationList';
import { CustomSorter } from '../Sorter';
/**
 * Property definition 
 */
interface ICustomerListProps extends IcommonProps {
    orgs: any;
    subOrgs: any;
    notifyActiveClick: any;
    loading: boolean;
    subOrgLoading: boolean;
    emptyText: string;
    notifyShowSubsClicked: any;
    subOrgListText: string;
}

/**
 * State definition
 */
interface ICustomerListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    selectedRowKeys: Array<string>;    
    childColumnNames: any;
    emptyText: string;
    subOrgLoading: boolean;
    subOrgListText: string;
}

/**
 * Listing component for displaying the organization
 */
export default class CustomerList extends React.Component<ICustomerListProps, ICustomerListState> {

    rowClass: string = 'rows';

    constructor(props: ICustomerListProps) {
        super(props);
        this.state = {
            columnData: [],
            columns: [],
            pagination: {},
            loading: true,
            selectedRowKeys: [],
            childColumnNames: ['name', 'value'],
            emptyText: '',
            subOrgLoading: this.props.subOrgLoading,
            subOrgListText: this.props.subOrgListText
        };        
    }

    componentDidMount() {
        strings.setLanguage(navigator.language);
        this.componentWillReceiveProps(this.props);

    }

    componentWillReceiveProps(nextProps: any) {
        let columnData: any[] = this.buildData(nextProps.orgs);
        let columns = this.buildColumns(nextProps);
        const pagination = { ...this.state.pagination };
        pagination.total = nextProps.orgs.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalOrgTxt, total);
        };
        this.setState({
            loading: nextProps.loading,
            columnData: columnData,
            columns: columns,
            pagination,
            emptyText: nextProps.orgs.length === 0 ? 'No data' : '',
            subOrgLoading: nextProps.subOrgLoading,
            subOrgListText: nextProps.subOrgListText
        });
    }

    render() {
        console.log('OrgList render called', this.state.columnData);
        return (           
            <Table 
                className="OrganizationList"
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                pagination={this.state.pagination}
                rowKey={record => record.organizationid}
                loading={this.state.loading}
                rowClassName={(record, index) => 'rows'}
                expandRowByClick={true}
                locale={{ emptyText: this.state.emptyText }} 
                expandedRowRender={this._expandRowRender}
                onExpand={this.onExpand}
            />        
        );            
    }

    /**
     * Render function called when row is expanded. Returns the HTML elements to display
     */
    _expandRowRender = (record: any, expanded: any, expandedRowKeys: any) => {
        console.log('expandRowRender', record);
        console.log('expandRowRender', expanded);
        console.log('expandedRowKeys', expandedRowKeys);       
        return(
            <OrganizationList 
                organizationID={this.props.organizationID} 
                rosterID={this.props.rosterID} 
                organizationName={this.props.organizationName}
                enableTitleSpace={this.props.enableTitleSpace}
                orgs={this.props.subOrgs.has(record.organizationid) ? 
                            this.props.subOrgs.get(record.organizationid) : []}
                notifyActiveClick={''}
                loading={this.state.subOrgLoading}
                emptyText={this.state.subOrgListText}
                isCustomer={true}
            />
        );
    }

    /**
     * Notifies Profiles Component to fetch last baseline tests for the record
     * @param record Record that is expanded
     */
    getSubOrgs(record: any) {
        this.props.notifyShowSubsClicked(record.organizationid);
    }

    /**
     * This function builds the data required by the Table component to display the Organizations
     * @param orgs Organization array containing the Organizations to be dispalyed
     */
    private buildData(orgs: Array<any>) {
        let columnData: Array<any> = [];
        orgs.forEach( (element: any) => {
            let data = {
                organizationid: element.organizationid,
                name: element.name,
                contactfirstname: element.contactfirstname,
                contactlastname: element.contactlastname,
                contactphone: element.contactphone,
                contactemail: element.contactemail,
                profiles: element.totalAthletes,
                tests: element.totalTests,
                baselines: element.totalBaselines,
                address: element.address,
                email: element.email,
                website: element.website,
                active: element.active,
                isprimary: element.isprimary,
                enableprivacy: element.enableprivacy
            };
            columnData.push(data);
        }); 
        return columnData;
    }
  
    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns(nextProps: any) {
        let columns = [
          {
            title: strings.lsNameTxt,
            dataIndex: 'name',
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            className: 'rows',
            render: (text: any, obj: any) => (
                <Row type="flex" align="middle">
                    <div
                        className={'clipped'}
                        style={{width: '135px'}}
                        title={text}
                    >
                        {text} 
                    </div>
                    &nbsp; {obj.enableprivacy && <img className="lockIcon" src={require('../../images/lock.png')}/>}
                </Row>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Profiles',
            dataIndex: 'profiles',
            sorter: (a: any, b: any) => a.profiles - b.profiles,
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Tests',
            dataIndex: 'tests',
            sorter: (a: any, b: any) => a.tests - b.tests,
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '150px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: 'Baselines',
            dataIndex: 'baselines',
            sorter: (a: any, b: any) => a.baselines - b.baselines,
            className: 'rows',
            render: (text: any) => (
                <div
                    className={'clipped'}
                    style={{width: '125px'}}
                    title={text}
                >
                {text}
                </div>),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsAction,
            dataIndex: 'organizationid',            
            render: (text: any, record: any) => (
                <div>
                    {/* <Link 
                        className="linkSpacing"
                        to={'/organization/edit/' + record.organizationid}
                    >{strings.lsViewTxt}
                    </Link> */}
                    <Link 
                        // className="linkSpacing" 
                        to={'/customer/edit/' + record.organizationid}
                    >{!record.isprimary ? strings.lsEditTxt + ' | ' : strings.lsEditTxt}
                    </Link>
                    {record.isprimary ? '' : <a 
                        onClick={ (e) => {    
                            console.log('record in onclick', record);  
                            console.log('e', e);
                            console.log('text', text);
                            e.stopPropagation();               
                            this.props.notifyActiveClick(record.active === 0 ? 1 : 0, record.organizationid, record); }
                        }
                    >{record.active === 0 ? strings.lsActivateTxt : strings.lsDeactivateTxt}
                    </a>}
                </div>
            ),
          }
        ];
        return columns;
    }

    /**
     * Fetches the test list for the player whose profile is expanded
     * This function is called by list itself
     */
    private onExpand = (expanded: any, record: any) => {
        if (expanded) {
            if (!this.props.subOrgs.has(record.organizationid)) {
                this.getSubOrgs(record);
                this.setState({
                    subOrgLoading: true
                });
            }
        }
    }    
}


// WEBPACK FOOTER //
// ./src/components/customer/CustomerList.tsx